import client from 'client';

export type BannedCountiesTypes = {
    values?: Array<{ value: string }>;
};

export const getBannedCountriesRequest = async (
    accountId: number,
    eventId: number
): Promise<BannedCountiesTypes> => {
    const url = `/api/v1/accounts/${accountId}/events/${eventId}/attributes/country`;
    const response = await client().get(url);
    return response.data;
};
